// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UmMG","rightAdornment":"Header_rightAdornment__1xRah"};